export const deleteChannelSuccess = {
  title: '已成功更新',
};
